import "./ThematicPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentArea, HeroWithImageThematic } from "/App.Components";
import { ThematicPageProps } from "/Models/Generated/ThematicPageProps";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";

const ThematicPage = ({
  pageHeader,
  contentArea,
  hiddenH1,
}: ThematicPageProps) => (
  <div className="thematic-page-norad">
    {hiddenH1 && <h1 className="thematic-page-norad__hidden-h1">{hiddenH1}</h1>}
    {pageHeader && <HeroWithImageThematic {...pageHeader} />}
    <div className="thematic-page-norad__main-content">
      <ContentArea
        {...contentArea}
        contentAreaType={ContentAreaType.FullWidth}
        margin={ContentAreaItemMargin.Huge}
      />
    </div>
  </div>
);

export default ThematicPage;
